module.exports = __webpack_public_path__ + "img/jx2.2ffc2a54.png";